import axios from "axios";

const STORAGE_KEY = "apropo.impersonation";

export function saveImpersonationSession(token, metadata) {
  if (!token) throw new Error("Impersonation token is required");

  axios.defaults.headers.common["Authorization"] = token;
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(metadata || {}));
}

export function readImpersonationSession() {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    sessionStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function clearImpersonationSession() {
  delete axios.defaults.headers.common["Authorization"];
  sessionStorage.removeItem(STORAGE_KEY);
}
